import request from '@/utils/request'

// 获取电脑端登录信息(仅电脑端)
export function getPcLoginInfo(query) {
  return request({
    url: '/app/auth/getPcLoginInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
//登陆
export function login(data) {
  return request({
    url: '/huaxi/user/login?phone=' + data.phone + '&code=' + data.code + '&entryType=' + data.entryType + '&password=' + data.password,
    method: 'post',
  })
}
//发送验证码
export function send_code(data) {
  return request({
    url: '/huaxi/user/send_code?phone=' + data.phone + '&action=' + data.action,
    method: 'post',
  })
}
//修改账号密码
export function update_password(data) {
  return request({
    url: '/huaxi/user/update_password?phone=' + data.phone + '&newPassword=' + data.newPassword + '&code=' + data.code,
    method: 'post',
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js